import { getDownload } from '../utils/get-download';

export const useDateIntoCSV = <T>(
  filename?: string,
  headLine?: Map<string, string>,
  keysIgnore: Set<string> = new Set()
) => {
  const onDownload = (data: Array<T>) => {
    getDownload(
      'data:text/csv;charset=utf-8,' + (
        headLine
          ? [...headLine.keys()]
              .filter((key) => !keysIgnore.has(key))
              .map((key) => headLine.get(key))
              .join(';') + '\n'
          : ''
      ) +
        data
          .map((item) => {
            // @ts-ignore
            return [...headLine.keys()]
              .filter((key) => !keysIgnore.has(key))
              .map((key) =>
                // @ts-ignore
                typeof item[key] === 'object' && 'name' in item[key]
                  ? item[key].name
                  : // @ts-ignore
                  typeof item[key] === 'boolean'
                  ? item[key]
                    ? 'Да'
                    : 'Нет'
                  : // @ts-ignore
                  typeof item[key] === 'string'
                  ? item[key].replaceAll(';', ', ')
                  : item[key]
              )
              .join(';');
          })
          .join('\n'),
      filename
    );
  };

  return { onDownload };
};
